require('whatwg-fetch')

try {
    if (window.localStorage) {
        window.__rescueErrors = JSON.parse(localStorage.getItem('__rescueErrors') || '[]')

        const storedLogs = JSON.parse(localStorage.getItem('__rescueLogs') || '[]')
        window.__rescueLogs = (Array.isArray(storedLogs) ? storedLogs : []).slice(-10)

        try {
            localStorage.setItem('__rescueLogs', JSON.stringify(window.__rescueLogs))
        } catch (exSet) {
            window.Sentry && window.Sentry.captureException(exSet)
        }
    } else {
        window.__rescueErrors = []
        window.__rescueLogs = []
    }
} catch (ex) {
    window.Sentry && window.Sentry.captureException(ex)
    window.__rescueErrors = []
    window.__rescueLogs = []
}

const isEntryLoggable = (obj) => {
    try {
        JSON.stringify(obj)
        return true
    } catch (err) {
        return false
    }
}

// Se não tiver em desenvolvimento salva os logs em localStorage para consultas futuras
if (!IS_DEV) {
    for (const level of ['log', 'info', 'error', 'warn', 'trace']) {
        const realLog = console[level]

        console[level] = function () {
            const args = Array.prototype.slice.call(arguments)

            const isErrorEntry = level === 'error' || args.some((a) => a instanceof Error)

            if (isErrorEntry && isEntryLoggable(args)) {
                window.__rescueLogs.push({ level, args, url: location.href, online: navigator.onLine })
                window.__rescueLogs = window.__rescueLogs.slice(-10)

                if (window.localStorage) {
                    const persistLogs = (logs) => {
                        try {
                            localStorage.setItem('__rescueLogs', JSON.stringify(logs))
                        } catch (ex) {
                            if (logs.length > 0) {
                                persistLogs(logs.slice(1))
                            } else {
                                try {
                                    localStorage.removeItem('__rescueLogs')
                                } catch (ex2) {
                                    window.Sentry && window.Sentry.captureException(ex2)
                                }
                            }
                        }
                    }

                    persistLogs(window.__rescueLogs)
                }
            }

            if (IS_DEV) {
                realLog.apply(console, arguments)
            }
        }
    }
}

// O Rescue cuidará de escutar erros e reporta-los.

const reportMessage = (message) => {
    const data = {
        message,
        data: JSON.stringify({
            instanceCode: window.__instanceCode,
            userId: window.__userId,
            url: location.href,
            adblockEnabled: window.__userIsUsingAdblockOrRelated,
            version: window.__version,
            buildName: window.__name,
            slugName: window.__slugname,
            navigator: {
                online: navigator.onLine,
                appCodeName: navigator.appCodeName,
                appName: navigator.appName,
                appVersion: navigator.appVersion,
                cookieEnabled: navigator.cookieEnabled,
                hardwareConcurrency: navigator.hardwareConcurrency,
                language: navigator.language,
                platform: navigator.platform,
                product: navigator.product,
                productSub: navigator.productSub,
                userAgent: navigator.userAgent,
                vendor: navigator.vendor,
                vendorSub: navigator.vendorSub
            },
            token: window.__sessionToken
        }),
        when: new Date(),
        source: 'sci-online-frontend'
    }

    if (!IS_DEV) {
        // fetch('//microsistec-rescue.appspot.com/api/messages', {
        //     'method': 'post',
        //     'headers': {
        //         'Content-Type': 'application/json',
        //         'Accept': 'application/json'
        //     },
        //     'body': JSON.stringify(data)
        // }).catch((ex) => {
        //     console.log(ex)
        // })
    } else {
        console.log({ errorInfo: data })
    }
}

const report = (error, message, stack) => {
    let token = null

    const tokenEl = document.getElementById('user-token')
    if (tokenEl) {
        token = tokenEl.value
    }

    const data = {
        message,
        data: JSON.stringify({
            stack: stack,
            instanceCode: window.__instanceCode,
            userId: window.__userId,
            url: location.href,
            adblockEnabled: window.__userIsUsingAdblockOrRelated,
            version: window.__version,
            buildName: window.__name,
            slugName: window.__slugname,
            navigator: {
                online: navigator.onLine,
                appCodeName: navigator.appCodeName,
                appName: navigator.appName,
                appVersion: navigator.appVersion,
                cookieEnabled: navigator.cookieEnabled,
                hardwareConcurrency: navigator.hardwareConcurrency,
                language: navigator.language,
                platform: navigator.platform,
                product: navigator.product,
                productSub: navigator.productSub,
                userAgent: navigator.userAgent,
                vendor: navigator.vendor,
                vendorSub: navigator.vendorSub
            },
            token: window.__sessionToken
        }),
        file: error.filename || 'none',
        when: new Date(),
        source: 'sci-online-frontend'
    }

    const reported = { info: data, error: [error] }

    window.dispatchEvent(new CustomEvent('rescue:error', {
        'detail': reported
    }))

    window.__rescueErrors.push(data)

    if (window.localStorage) {
        localStorage.setItem('__rescueErrors', JSON.stringify(window.__rescueErrors.slice(-50)))
    }

    if (!error.skip) {
        if (!IS_DEV) {
            // fetch('//microsistec-rescue.appspot.com/api/messages', {
            //     'method': 'post',
            //     'headers': {
            //         'Content-Type': 'application/json',
            //         'Accept': 'application/json'
            //     },
            //     'body': JSON.stringify(data)
            // }).catch((ex) => {
            //     console.log(ex)
            // })
        }

//         let errorModal = document.getElementsByClassName('fatal-error-modal')[0];
//
//         if (IS_DEV && document.body && !error.isHidden && !errorModal) {
//             let node = document.createElement('div');
//             node.innerHTML = `
// <div style="position: fixed; background-color: #ff8c6f; top: 0; bottom: 0; left: 0; right: 0; z-index: 9999999999999" class="fatal-error-modal">
//     <a href="javascript:;" class="fatal-error-close-button" style="color: white; font-weight: bold; font-size: 50px; position: absolute; right: 15px; top: 15px; line-height: 28px; text-decoration: none">
//         &times;
//     </a>
//     <div style="margin: 0 auto; width: 80%">
//         <h3 style="color: white; font-weight: bold; font-family: sans-serif; font-size: 25px; text-shadow: 1px 1px 0px rgba(0,0,0,.3)">
//             Oooops... Aconteceu um erro fatal que provavelmente impedirá você de usufruir do nosso serviço, esse erro já foi enviado para nossos desenvolvedores e em breve será solucionado! Você pode tentar recarregar a página e tentar novamente enquanto isso.
//         </h3>
//         <div style="margin-top: 50px; text-align: left">
//             <button class="fatal-error-home-button" style="color: black; font-size: 16px; padding: 4px 10px; border-radius: 3px; background-color: white; border: none; margin-right: 6px">página inicial</button>
//             <button class="fatal-error-reload-button" style="color: black; font-size: 16px; padding: 4px 10px; border-radius: 3px; background-color: white; border: none;">atualizar página</button>
//         </div>
//     </div>
// </div>
// `;
//             let closeButton = node.getElementsByClassName('fatal-error-close-button')[0];
//             let reloadButton = node.getElementsByClassName('fatal-error-reload-button')[0];
//             let homeButton = node.getElementsByClassName('fatal-error-home-button')[0];
//             closeButton.addEventListener('click', (event) => {
//                 document.body.removeChild(node);
//             });
//             homeButton.addEventListener('click', (event) => {
//                 location.href = '/';
//             });
//             reloadButton.addEventListener('click', (event) => {
//                 location.href = location.href;
//             });
//             document.body.appendChild(node)
//         }
    }
}

// window.onerror = function (message, file, line, col, error) {
//     // TODO: isso
//
//     return false
// }
//
// window.addEventListener('error', function (event, a, b) {
//     if (event.error) {
//         report(event.error, event.error.message, event.error.stack)
//     } else {
//         report(event, event.message, event.stack)
//     }
//
//     return false
// })
//
// window.addEventListener('unhandledrejection', function (event, a, b) {
//     let reason = null
//     if (event.detail) {
//         reason = event.detail.reason
//     } else {
//         reason = event.reason
//     }
//
//     report(reason, reason.message, reason.stack)
// })

window.rescue = {
    error: (message) => {
        if (IS_DEV) {
            console.error(message)
        }
        reportMessage(message)
    }
}



// WEBPACK FOOTER //
// ./resources/assets/javascript/rescue.js